import type { SxProps, Theme } from '@mui/material';

export const heroSectionRootSx: SxProps<Theme> = {
  mb: 2,
};

export const heroSectionTitleSx: SxProps<Theme> = {
  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
  fontWeight: 700,
};

export const heroSectionBodySx: SxProps<Theme> = {
  maxWidth: 560,
  fontSize: { xs: '1rem', sm: '1.1rem' },
  opacity: 0.9,
};

export const heroSectionButtonSx: SxProps<Theme> = {
  mt: 2,
  px: 4,
  py: 1.5,
  fontSize: '1.1rem',
};
